import React, { Component } from "react";
import { MapContainer, TileLayer, MapConsumer } from "react-leaflet";
import L from "leaflet";
import { withAppState } from "../../../../shared/containers/containerAppState";
import { withMapControl } from "../../../../shared/containers/containerMapControl";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { states } from "../../../../reducers/queriesStates";
import { withSignalR } from "../../../../shared/containers/containerSignalR";
import TopRightMapControl from "../../../LayerMapCotrol/TopRightMapControl";
import BaseLayerMapControl from "../../../LayerMapCotrol/BaseLayerMapControl";
import MapMarkerLastState from "./MapMarkerLastState";

class MonitoringTaskTripsMapLastState extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxLocation: null,
      minLocation: null,
      units: [],
    };
  }

  componentDidMount() {
    const { monitoringTaskTrips } = this.props;

    if (monitoringTaskTrips.length > 0) {
      const _units = getUnits(monitoringTaskTrips);

      const locations = getMaxMinLocations(_units);
      this.setState({ ...locations, units: _units });
    }
  }

  componentDidUpdate(prevProps) {
    const { monitoringTaskTripsDataState, monitoringTaskTrips } = this.props;
    const { units } = this.state;

    if (monitoringTaskTrips.length > 0) {
      const _units = getUnits(monitoringTaskTrips);

      if (monitoringTaskTripsDataState === states.READY && prevProps.monitoringTaskTripsDataState === states.REQUEST) {
        const locations = getMaxMinLocations(_units);
        this.setState({ ...locations });
      }

      if (units.length > 0) {
        const isNeedUpdatelastPositions = _units.some((x) => {
          return units.some((y) => {
            return x.lastActive !== y.lastActive;
          });
        });

        if (isNeedUpdatelastPositions) {
          this.setState({ units: _units });
        }
      } else {
        this.setState({ units: _units });
      }
    }
  }

  render() {
    const { mapBaseLayer, isSideBarOpen } = this.props;
    const height = window.innerHeight - 70;
    const { maxLocation, minLocation, units } = this.state;

    return (
      <div>
        <MapContainer
          key={` ${mapBaseLayer.name}  ${isSideBarOpen}`}
          center={[53, 27]}
          zoom={15}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          crs={mapBaseLayer.crs}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          style={{ height: `${height}px` }}
        >
          <MapConsumer>
            {(map) => {
              if (minLocation !== undefined && minLocation !== null && minLocation.lng !== Infinity) {
                map.fitBounds(
                  new L.latLngBounds([new L.latLng(minLocation.lng, minLocation.lon), new L.latLng(maxLocation.lng, maxLocation.lon)]).pad(
                    0.2
                  )
                );
              }

              return null;
            }}
          </MapConsumer>

          {mapBaseLayer.url.map((_url, index) => {
            return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
          })}

          {units.map((unit) => {
            return <MapMarkerLastState unit={unit} key={unit.id + unit.lastState.lastActive} />;
          })}

          {this.props.children}
        </MapContainer>

        <TopRightMapControl>
          <BaseLayerMapControl />
        </TopRightMapControl>
      </div>
    );
  }
}

const getMaxMinLocations = (units) => {
  const longitudes = units.map((x) => {
    return x.lastState.long;
  });

  const latitudes = units.map((x) => {
    return x.lastState.lat;
  });

  const maxLocation = {
    lon: Math.max(...longitudes),
    lng: Math.max(...latitudes),
  };

  const minLocation = {
    lon: Math.min(...longitudes),
    lng: Math.min(...latitudes),
  };

  return { maxLocation, minLocation };
};

export default withSignalR(withAppState(withMapControl(withMonitoringTaskTrips(React.memo(MonitoringTaskTripsMapLastState)))));

const getUnits = (monitoringTaskTrips) => {
  const _units = [];

  monitoringTaskTrips.forEach((taskTrip) => {
    taskTrip.units.forEach((unit) => {
      const isSome = _units.some((x) => {
        return x.id === unit.id;
      });

      if (!isSome) _units.push(Object.assign({}, unit, {}));
    });
  });

  return _units;
};
